import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/service/common.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { XmlToJsonParserService } from 'src/app/service/xml-to-json-parser.service';

@Component({
  selector: 'app-add-meal-screen',
  templateUrl: './add-meal-screen.component.html',
  styleUrls: ['./add-meal-screen.component.scss']
})
export class AddMealScreenComponent implements OnInit {
  isShow: boolean = true;
  /*  meals: any = [
    { id: '1', Meal: 'Baby Meal' },
    { id: '2', Meal: 'Bland Meal' },
    { id: '3', Meal: 'Child Meal' },
    { id: '4', Meal: 'Diabetic Meal' },
    { id: '5', Meal: 'Fresh fruit plate Meal' },
    { id: '6', Meal: 'Gluten free Meal' },
    { id: '7', Meal: 'High fibre Meal' },
    { id: '8', Meal: 'Hindu Meal' },
    { id: '9', Meal: 'Hindu vegetarian Meal' },
    { id: '10', Meal: 'Kosher Meal' },
    { id: '11', Meal: 'Lacto ovo vegetarian Meal ' },
    { id: '12', Meal: 'Low calorie Meal ' },
    { id: '13', Meal: 'Low fat Meal ' },
    { id: '14', Meal: 'Low lactose Meal' },
    { id: '15', Meal: 'Low protein/ potassium Mea' },
    { id: '16', Meal: 'Low purine' },
    { id: '17', Meal: 'Low salt/ sodium Meal' },
    { id: '18', Meal: 'Muslim Meal' },
    { id: '19', Meal: 'Seafood Meal' },
    { id: '20', Meal: 'Vegan vegetarian Meal' },
    { id: '21', Meal: 'Vegetarian jain meal Meal' }
  ];
 */
  public getMealsDetail: any = [];
  mealDetailScreenXmlParse: any;
  segmentList: any;
  flightList: any;
  priceClassList: any;
  public flightListIds: any = [];
  public flightSegment: any = [];
  public mealsPrices: any = [];
  public meals: any = [];
  public mealScreenData: any = [];
  public mealsRefs: any = [];
  public mealsDetails: any = [];
  public mealsdropDownList: any = [];

  constructor(private http: HttpClient, private sandboxPageStateService: SandboxPageStateService, private xmlToJsonParserService: XmlToJsonParserService, private commonService: CommonService) {}

  ngOnInit(): void {
    this.http.get('/assets/json/add-meal-service-response/add-meal-screen-response.xml', { responseType: 'text' }).subscribe((res: any) => {
      this.mealDetailScreenXmlParse = this.xmlToJsonParserService.parseXMLToJSON(res);

      this.mapToMealsScreen();
    });
  }
  servHide() {}

  mapToMealsScreen() {
    let seatEnvelope = this.mealDetailScreenXmlParse['SOAP:ENVELOPE'];
    let seatBody = seatEnvelope['SOAP:BODY'][0];
    let searviceListReponse = seatBody.SERVICELISTRS[0];
    // console.log('searvice list', searviceListReponse);
    let offersItems = searviceListReponse.ALACARTEOFFER[0].ALACARTEOFFERITEM;
    offersItems.splice(0, 10);
    let mealArray = offersItems.splice(0, 13);
    let dataList = searviceListReponse.DATALISTS[0];
    let serviceDefinationList = dataList.SERVICEDEFINITIONLIST[0].SERVICEDEFINITION;
    let flightSegment = dataList.FLIGHTSEGMENTLIST[0].FLIGHTSEGMENT;
    this.mapFlighIds(flightSegment);
    this.mapMeals(serviceDefinationList);
    this.mapMealsScreenData(mealArray);
  }

  mapFlighIds(flightSegment: any) {
    this.flightSegment = [];
    let len = flightSegment?.length;
    if (len > 0) {
      flightSegment.forEach((flightList: any) => {
        this.flightSegment.push(flightList.$.SEGMENTKEY);
        this.mealsDetails.push({ flightNumber: flightList.$.SEGMENTKEY, mealsdropDownList: [] });
      });
    }
  }

  mapMeals(serviceDefinationList: any) {
    this.meals = [];
    let len = serviceDefinationList.length;
    if (len > 0) {
      serviceDefinationList.forEach((serviceList: any) => {
        this.mealsRefs.push(serviceList.$.SERVICEDEFINITIONID);
        this.meals.push({ meals: serviceList.NAME[0], mealkey: serviceList.$.SERVICEDEFINITIONID });
      });
    }
  }

  mapMealsScreenData(mealArray: any) {
    for (let items of mealArray) {
      let flightNumber = items.ELIGIBILITY[0].SEGMENTREFS[0];
      let flightDetailIndex: any = this.flightSegment.indexOf(flightNumber);
      let mealsref = items.SERVICE[0].SERVICEDEFINITIONREF[0];
      let mealsIndex: any = this.mealsRefs.indexOf(mealsref);
      this.mealsDetails[flightDetailIndex].mealsdropDownList.push({
        name: this.meals[mealsIndex].meals,
        price: items.UNITPRICEDETAIL[0].TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0]._
      });
    }
    // console.log('SSSS', this.mealsDetails);
  }
}
